<template>
    <div class="vx-row match-height">
      <div class="vx-col w-full">
        <vx-card class="mt-2">
          <vs-tabs vs-alignment="fixed" alignment="fixed">
            <vs-tab :label="$t('Draft')">
              <draft></draft>
            </vs-tab>
            <vs-tab :label="$t('ReviewQueue')">
              <ReviewQueue></ReviewQueue>
            </vs-tab>
            <vs-tab :label="$t('Confirmed')">
              <confirm></confirm>
            </vs-tab>
            <vs-tab :label="$t('InProcess')">
              <proccessing></proccessing>
            </vs-tab>
            <vs-tab :label="$t('Sent')">
              <sent></sent>
            </vs-tab>
            <vs-tab :label="$t('Delivered')">
              <delivered></delivered>
            </vs-tab>
            <vs-tab :label="$t('IgnoredOrders')">
              <ignoredOrders></ignoredOrders>
            </vs-tab>
            <vs-tab :label="$t('AllPurchaseOrder')">
              <allPreInvoice></allPreInvoice>
            </vs-tab>
          </vs-tabs>
        </vx-card>
      </div>
    </div>
  </template>
  <script>
  import confirm from "../PurchaseOrder/Confirm.vue"
  import draft from "../PurchaseOrder/DraftPurchaseOrder.vue"
  import ReviewQueue from "./ReviewQueue.vue";
  import proccessing from "../PurchaseOrder/Processing.vue"
  import sent from "../PurchaseOrder/Sent.vue"
  import delivered from "../PurchaseOrder/Delivered.vue"
  import ignoredOrders from "../PurchaseOrder/IgnoredOrders.vue"
  import allPreInvoice from "../PurchaseOrder/AllPurchaseOrder.vue"
  export default {
    components: {
      draft,
      confirm,
      ReviewQueue,
      proccessing,
      sent,
      delivered,
      ignoredOrders,
      allPreInvoice
    },
  };
  </script>